var _defs, _circle, _path, _path2, _circle2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotonesSvg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2503.45 1222.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d91111;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-5 {\n        fill: #a81414;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#26130a",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 606.33,
    cy: 611.08,
    r: 525.8,
    transform: "translate(-254.51 607.72) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2196.05,341.64H728.6v545.98h1467.45c125.29,0,226.86-101.57,226.86-226.86v-92.26c0-125.29-101.57-226.86-226.86-226.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m2228.57,384.68H802.21v459.89h1426.37c80.26,0,145.55-103.15,145.55-229.94s-65.3-229.94-145.55-229.94Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 606.33,
    cy: 611.08,
    r: 387.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1253.71,467.41h31.8c10.73,0,18.78,2.88,24.14,8.64,5.36,5.76,8.05,14.2,8.05,25.32v13.54c0,11.12-2.68,19.56-8.05,25.32-5.37,5.76-13.42,8.64-24.14,8.64h-10.21v55.94h-21.59v-137.4Zm31.8,61.83c3.53,0,6.18-.98,7.95-2.94s2.65-5.3,2.65-10.01v-16.29c0-4.71-.88-8.05-2.65-10.01s-4.42-2.94-7.95-2.94h-10.21v42.2h10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1358.92,467.41h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm16.68-31.8h23.55l-21,22.57h-16.29l13.74-22.57Zm6.87,123.66l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1446.85,597.85c-5.5-5.95-8.24-14.49-8.24-25.62v-72.23c0-11.12,2.75-19.66,8.24-25.62,5.5-5.95,13.48-8.93,23.95-8.93s18.45,2.98,23.95,8.93c5.5,5.96,8.24,14.5,8.24,25.62v11.78h-20.41v-13.15c0-9.03-3.73-13.54-11.19-13.54s-11.19,4.51-11.19,13.54v75.18c0,8.9,3.73,13.35,11.19,13.35s11.19-4.45,11.19-13.35v-26.89h-10.8v-19.63h31.21v44.95c0,11.12-2.75,19.66-8.24,25.62-5.5,5.96-13.48,8.93-23.95,8.93s-18.45-2.98-23.95-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1536.56,467.41h21.59v137.4h-21.59v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1593.87,467.41h27.09l21,82.25h.39v-82.25h19.24v137.4h-22.18l-25.91-100.3h-.39v100.3h-19.24v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1713.99,467.41h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1846.68,467.41h32.98c10.73,0,18.78,2.88,24.14,8.64,5.36,5.76,8.05,14.2,8.05,25.32v69.49c0,11.12-2.68,19.56-8.05,25.32-5.37,5.76-13.42,8.64-24.14,8.64h-32.98v-137.4Zm32.58,117.77c3.53,0,6.25-1.05,8.15-3.14,1.9-2.09,2.85-5.5,2.85-10.21v-71.45c0-4.71-.95-8.11-2.85-10.21-1.9-2.09-4.61-3.14-8.15-3.14h-10.99v98.14h10.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1946,467.41h58.89v19.63h-37.29v36.31h29.64v19.63h-29.64v42.2h37.29v19.63h-58.89v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1474.82,639.16h29.25l22.38,137.4h-21.59l-3.93-27.28v.39h-24.54l-3.93,26.89h-20.02l22.38-137.4Zm23.55,91.86l-9.62-67.92h-.39l-9.42,67.92h19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1560.2,769.6c-5.37-5.95-8.05-14.49-8.05-25.62v-7.85h20.41v9.42c0,8.9,3.73,13.35,11.19,13.35,3.66,0,6.44-1.08,8.34-3.24,1.9-2.16,2.85-5.66,2.85-10.5,0-5.76-1.31-10.83-3.93-15.21-2.62-4.38-7.46-9.65-14.53-15.8-8.9-7.85-15.11-14.95-18.65-21.3-3.53-6.35-5.3-13.51-5.3-21.49,0-10.86,2.75-19.27,8.24-25.22,5.5-5.95,13.48-8.93,23.95-8.93s18.16,2.98,23.46,8.93c5.3,5.96,7.95,14.5,7.95,25.62v5.69h-20.41v-7.07c0-4.71-.92-8.15-2.75-10.31-1.83-2.16-4.51-3.24-8.05-3.24-7.2,0-10.8,4.39-10.8,13.15,0,4.97,1.34,9.62,4.02,13.94,2.68,4.32,7.56,9.55,14.62,15.7,9.03,7.85,15.24,14.99,18.65,21.4,3.4,6.41,5.1,13.94,5.1,22.57,0,11.26-2.78,19.89-8.34,25.91-5.56,6.02-13.64,9.03-24.24,9.03s-18.39-2.98-23.75-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1648.53,639.16h58.89v19.63h-37.29v36.31h29.64v19.63h-29.64v42.2h37.29v19.63h-58.89v-137.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m1744.12,769.6c-5.37-5.95-8.05-14.49-8.05-25.62v-7.85h20.41v9.42c0,8.9,3.73,13.35,11.19,13.35,3.66,0,6.44-1.08,8.34-3.24,1.9-2.16,2.85-5.66,2.85-10.5,0-5.76-1.31-10.83-3.93-15.21-2.62-4.38-7.46-9.65-14.53-15.8-8.9-7.85-15.11-14.95-18.65-21.3-3.53-6.35-5.3-13.51-5.3-21.49,0-10.86,2.75-19.27,8.24-25.22,5.5-5.95,13.48-8.93,23.95-8.93s18.16,2.98,23.46,8.93c5.3,5.96,7.95,14.5,7.95,25.62v5.69h-20.41v-7.07c0-4.71-.92-8.15-2.75-10.31-1.83-2.16-4.51-3.24-8.05-3.24-7.2,0-10.8,4.39-10.8,13.15,0,4.97,1.34,9.62,4.02,13.94,2.68,4.32,7.56,9.55,14.62,15.7,9.03,7.85,15.24,14.99,18.65,21.4,3.4,6.41,5.1,13.94,5.1,22.57,0,11.26-2.78,19.89-8.34,25.91-5.56,6.02-13.64,9.03-24.24,9.03s-18.39-2.98-23.75-8.93Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m518.38,841.86c71.5-61.62,121.42-135.94,136.68-230.1,15.03-92.75.32-180.83-46.9-262.83,26.02,28.43,46.23,60.73,62.27,95.7,15.98,34.82,26.85,71.23,32.68,110.19,2.35-2.14,3.98-3.5,5.47-5,18.73-18.79,29.38-41.86,35.36-67.33,6.29-26.8,6.07-53.81,2.15-80.9-.2-1.42-.34-2.85.37-4.47,1.83,7.32,3.9,14.59,5.46,21.97,13.81,65.13,12.13,129.51-9.95,192.78-14.15,40.56-36.85,76.18-64.15,109-39.34,47.28-86.36,85.02-141.39,112.64-5.92,2.97-12.03,5.57-18.05,8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m647.52,552.82c-1.57,10.57-2.9,21.19-4.76,31.71-9.46,53.45-26.39,104.26-54.09,151.18-35.18,59.58-84.94,102.4-149.01,128.3-10.49,4.24-21.9,6.82-33.14,8.5-25.89,3.88-46.23-7.95-56.81-31.85-6.26-14.15-8.82-29.17-9.72-44.45-1.76-29.89,1.34-59.42,7.74-88.78.8,5.03,1.5,10.09,2.41,15.1,2.42,13.33,6.31,26.21,12.25,38.42,16.72,34.39,45.35,47.65,82.34,38.1,22.67-5.85,42.75-17.17,61.94-30.13,59.2-39.97,99.42-94.74,124.04-161.22,6.17-16.66,10.1-34.15,15.06-51.26.36-1.25.7-2.5,1.05-3.75.23.04.46.08.69.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m654.33,773.04c85.81-70.05,122-162.16,126.26-269.24,14.69,18.1,25.74,38.98,32.4,63.58,35.63-37.82,52.53-82.15,55.15-132.86.64,3.19,1.33,6.37,1.9,9.57.58,3.28,1.21,6.57,1.54,9.89,8.06,79.63-15.17,149.98-63.86,212.45-18.74,24.04-42.62,42.66-67.71,59.69-25.52,17.31-52.51,32.03-80.59,44.75-1.41.64-2.85,1.22-5.1,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m734.34,468.19c-.06,11.46-9.06,20.2-20.65,20.06-11.16-.13-20.16-9.22-20.12-20.32.03-11.19,9.42-20.51,20.59-20.43,11.32.08,20.24,9.22,20.18,20.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m802.82,493.56c.07-10.6,8.25-18.65,18.9-18.58,10.56.07,18.71,8.33,18.64,18.9-.07,10.46-8.49,18.74-18.96,18.66-10.49-.09-18.64-8.42-18.57-18.98Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotonesSvg21);
export default __webpack_public_path__ + "static/media/BOTONES_SVG 21.ea2f5d90964cf12e7a29559dc9c0ffae.svg";
export { ForwardRef as ReactComponent };